// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__sQopp","actionsCol":"EnrolledClinics_actionsCol__ibefF"};